import type { PopWhatsIncludedItemData } from '@/app/[locale]/product/rings/_types';

export const popWhatsIncludedItems: PopWhatsIncludedItemData[] = [
  {
    description: 'pop_whats_included_charger_copy',
    image: {
      alt: 'ring_with_charger_image_alt',
      src: 'blue-sky/pop/pop_charger_set@3x',
    },
    title: 'pop_whats_included_charger_title',
  },
];
